(function () {
  'use strict';

  // ============================================================
  // bl-cart-segment-remove.js
  //
  // Intercepta cliques no link "Remove" de line-items que foram
  // split em múltiplos segments visuais (via bl-cart-line-marker.js).
  //
  // Reescreve o href de quantity=0 pra quantity=(total-segment),
  // deixando o handler default do LineItemQuantity (theme.js) processar.
  //
  // SE não houver split (data-bl-segment-qty ausente): no-op.
  // ============================================================

  var SEGMENT_QTY_ATTR = 'data-bl-segment-qty';
  var TOTAL_QTY_ATTR = 'data-bl-line-total-qty';

  function handleRemoveClick(event) {
    var link = event.target.closest('a[href*="/cart/change"]');
    if (!link) return;

    // Confirma que é Remove (quantity=0 no href)
    var url;
    try {
      url = new URL(link.href);
    } catch (e) {
      return;
    }
    var currentQty = url.searchParams.get('quantity');
    if (currentQty !== '0') return;  // não é Remove, é +/- → ignora

    // Procura o <line-item> parent
    var lineItem = link.closest('line-item');
    if (!lineItem) return;

    // Lê atributos do segment
    var segmentQty = parseInt(lineItem.getAttribute(SEGMENT_QTY_ATTR), 10);
    var totalQty = parseInt(lineItem.getAttribute(TOTAL_QTY_ATTR), 10);

    // Se atributos ausentes ou inválidos: line não foi split, deixa default
    if (!Number.isFinite(segmentQty) || !Number.isFinite(totalQty)) return;
    if (totalQty <= segmentQty) return;  // segment é o total: deixa zerar a linha

    // Calcula nova qty: backing total - este segment
    var newQty = totalQty - segmentQty;
    if (newQty <= 0) return;

    // Reescreve href in-place (handler default vai ler o NOVO href)
    url.searchParams.set('quantity', String(newQty));
    link.href = url.toString();

    // NÃO chama preventDefault nem stopPropagation: handler default
    // do LineItemQuantity (theme.js) vai processar normalmente com new qty.
  }

  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) {
      // Drawer pode não estar no DOM ainda em pageload — tenta novamente após DOMContentLoaded
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    // Capture phase: precisa rodar ANTES do listener do LineItemQuantity
    drawer.addEventListener('click', handleRemoveClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
